import React from 'react'

export default function Professional() {
  return (
    <div>Professional</div>
  )
}
